'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props as ProductListPaginationProps } from './product-list-pagination.component';
import dynamic from 'next/dynamic';

const DynamicProductListPaginationComponent: ComponentType<ProductListPaginationProps> = dynamic(
  () => import('./product-list-pagination.component')
);

export default DynamicProductListPaginationComponent;

export function calculateProductListPaginationPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 600 },
    { sinceWidth: 425, height: 520 },
    { sinceWidth: 525, height: 511 },
    { sinceWidth: 625, height: 472 },
    { sinceWidth: 768, height: 1070 },
    { sinceWidth: 1024, height: 1046 },
    { sinceWidth: 1442, height: 755 }
  ];

  return {
    heightSinceWidth
  };
}
